import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class DownloadSignalrService implements OnDestroy {
  public baseUrl = environment.api2BaseUrl;
  private hubConnection!: signalR.HubConnection;

  constructor(private http: HttpClient) { }

  async startConnection(token: string): Promise<boolean> {
    // If already connected, return true
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      return true;
    }

    // If hubConnection exists but is not connected, clear it for a clean retry
    if (this.hubConnection && this.hubConnection.state !== signalR.HubConnectionState.Connected) {
      this.hubConnection = undefined!;
    }

    let isRealtimeEnabled = false;
    try {
      isRealtimeEnabled = await this.http
        .get<boolean>(`${this.baseUrl}/config/realtimecommunication`)
        .toPromise();
    } catch (err) {
      console.error('Failed to check realtime communication config', err);
      return false;
    }

    if (!isRealtimeEnabled) {
      return false;
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.baseUrl}/download-status-hub`, {
        accessTokenFactory: () => token
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Critical)
      .build();

    try {
      await this.hubConnection.start();
      return true;
    } catch (err) {
      console.error('SignalR connection error', err);
      this.hubConnection = undefined!;
      return false;
    }
  }

  isConnected(): boolean {
    return this.hubConnection?.state === signalR.HubConnectionState.Connected;
  }

  joinDownloadGroup(saleId: number) {
    if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.invoke('JoinDownloadGroup', saleId)
        .catch(err => console.error('JoinDownloadGroup failed', err));
    }
  }

  onDownloadStatusUpdate(callback: (notification:any) => void) {
    this.hubConnection.on('DownloadStatusUpdate', callback);
  }


  forceCloseConnection() {
    if (this.hubConnection) {
      const connection = this.hubConnection;
      this.hubConnection = undefined!;

      connection.stop()
        .then(() => console.log('Download SignalR connection closed'))
        .catch(err => console.error('Failed to stop Download SignalR connection', err));
    }
  }

  ngOnDestroy(): void {
    this.forceCloseConnection();
  }
}
